<div class="mt-6">
  <div *ngIf="isUK()" class="flex flex-wrap justify-center gap-4">
    <a 
      href="https://www.gamstop.co.uk" 
      target="_blank" 
      rel="noopener"
      class="inline-block"
    >
      <img 
        src="/assets/gamstop-logo.png" 
        alt="GamStop"
        class="h-12 object-contain"
        onerror="this.style.display='none'"
      />
    </a>
    <a 
      href="https://www.gambleaware.org" 
      target="_blank" 
      rel="noopener"
      class="inline-block"
    >
      <img 
        src="/assets/gambleaware-logo.png" 
        alt="GambleAware"
        class="h-12 object-contain"
        onerror="this.style.display='none'"
      />
    </a>
  </div>
  
  <div *ngIf="isNL()" class="text-center">
    <p class="text-sm text-gray-400 mb-2">
      Verantwoord Gokken | 18+ Alleen
    </p>
    <a 
      href="https://www.gokkeninfo.nl" 
      target="_blank" 
      rel="noopener"
      class="text-primary hover:underline text-sm"
    >
      Gokken Info - Nederlandse Hulplijn
    </a>
  </div>

  <div *ngIf="!isUK() && !isNL()" class="text-center">
    <p class="text-sm text-gray-400 mb-2">
      Verantwoord Gokken | 18+ Alleen
    </p>
    <div class="flex flex-wrap justify-center gap-4">
      <a 
        href="https://www.gamstop.co.uk" 
        target="_blank" 
        rel="noopener"
        class="text-primary hover:underline text-sm"
      >
        GamStop
      </a>
      <a 
        href="https://www.gambleaware.org" 
        target="_blank" 
        rel="noopener"
        class="text-primary hover:underline text-sm"
      >
        GambleAware
      </a>
    </div>
  </div>
</div>

